module.exports = __webpack_public_path__ + "img/1.e8fed932.jpg";